// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__DFU6U","header":"MergedInvoice_header__2nne8"};